// ============================================================================
// CONFIGURATION CENTRALE FRELONS50
// Toutes les informations importantes sont centralisées ici (source unique).
// Modifiez ces valeurs pour mettre à jour l'ensemble du site.
// Les champs marqués "À COMPLÉTER" doivent être renseignés avant publication.
// ============================================================================

export const SITE = {
  brand: "FRELONS50",
  tagline: "Experts anti-nuisibles dans la Manche",
  taglineSecondary: "Intervention rapide contre frelons, guêpes et rongeurs",
  domain: "www.frelons50.com",
  url: "https://www.frelons50.com",

  // Contact
  phoneDisplay: "06 35 92 21 49",
  phoneHref: "tel:+33635922149",
  email: "destructionteilleul@gmail.com",
  emailHref: "mailto:destructionteilleul@gmail.com",

  // WhatsApp (activé)
  whatsappEnabled: true,
  whatsappNumber: "33635922149",
  whatsappHref: "https://wa.me/33635922149",

  // Disponibilité affichée (à ajuster selon la réalité)
  availability: "Intervention 7j/7 — Appels 24h/24",
  hours: [
    { day: "Lundi – Dimanche", value: "7j/7 sur rendez-vous" },
    { day: "Appels téléphoniques", value: "24h/24" },
  ],

  // Zone
  departement: "Manche (50)",
  addressLine: "5 route de Mortain, 50640 Le Teilleul",
  zoneShort: "Département de la Manche (50) et communes limitrophes selon disponibilité",

  // Réseaux sociaux (À COMPLÉTER — laisser vide pour masquer)
  social: {
    facebook: "",
    instagram: "",
    googleBusiness: "", // lien fiche Google Business
    googleReviews: "", // lien "Voir les avis Google"
    googleLeaveReview: "", // lien "Laisser un avis"
    mapsDirections: "https://www.google.com/maps/dir/?api=1&destination=5+route+de+Mortain+50640+Le+Teilleul", // itinéraire
  },

  // Certification (À VALIDER — ne pas afficher tant que non confirmé)
  certibiocide: {
    display: false, // passez à true uniquement si la certification est confirmée
    number: "À COMPLÉTER",
    label: "Technicien certifié Certibiocide",
  },
};

// ---------------------------------------------------------------------------
// COMMUNES / ZONES D'INTERVENTION
// ---------------------------------------------------------------------------
export const TOWNS = [
  "Le Teilleul",
  "Saint-Hilaire-du-Harcouët",
  "Mortain-Bocage",
  "Avranches",
  "Isigny-le-Buat",
  "Sourdeval",
  "Villedieu-les-Poêles",
  "Granville",
  "Coutances",
  "Saint-Lô",
  "Cherbourg-en-Cotentin",
];

// Pages locales SEO (contenu unique par commune, non dupliqué).
export const LOCALITIES = [
  {
    slug: "le-teilleul",
    name: "Le Teilleul",
    cp: "50640",
    blurb:
      "Basés au Teilleul, dans le sud-Manche, nous connaissons parfaitement le bocage local, ses longères en pierre et ses dépendances où frelons et guêpes aiment s'installer. C'est notre commune d'attache : nos délais d'intervention y sont particulièrement courts.",
    nearby: ["saint-hilaire-du-harcouet", "mortain-bocage", "sourdeval"],
  },
  {
    slug: "saint-hilaire-du-harcouet",
    name: "Saint-Hilaire-du-Harcouët",
    cp: "50600",
    blurb:
      "Proche de notre siège, Saint-Hilaire-du-Harcouët et ses environs mêlent zones pavillonnaires et habitat rural. Nous y intervenons rapidement contre les nids de frelons asiatiques et de guêpes ainsi que pour la dératisation.",
    nearby: ["le-teilleul", "isigny-le-buat", "mortain-bocage"],
  },
  {
    slug: "mortain-bocage",
    name: "Mortain-Bocage",
    cp: "50140",
    blurb:
      "Terrain vallonné et boisé, le secteur de Mortain-Bocage favorise l'installation de nids en hauteur dans les arbres. Nous évaluons l'accessibilité au cas par cas avant chaque intervention.",
    nearby: ["sourdeval", "le-teilleul", "saint-hilaire-du-harcouet"],
  },
  {
    slug: "avranches",
    name: "Avranches",
    cp: "50300",
    blurb:
      "Aux portes de la baie du Mont-Saint-Michel, Avranches associe centre urbain et maisons de bourg. Nous y traitons frelons, guêpes et rongeurs, chez les particuliers comme chez les professionnels.",
    nearby: ["isigny-le-buat", "villedieu-les-poeles", "granville"],
  },
  {
    slug: "isigny-le-buat",
    name: "Isigny-le-Buat",
    cp: "50540",
    blurb:
      "Vaste commune rurale, Isigny-le-Buat compte de nombreuses exploitations et bâtiments agricoles propices aux nids et aux rongeurs. Nous adaptons notre intervention à chaque configuration.",
    nearby: ["avranches", "saint-hilaire-du-harcouet", "le-teilleul"],
  },
  {
    slug: "sourdeval",
    name: "Sourdeval",
    cp: "50150",
    blurb:
      "Dans le bocage sourdevalais, les nids de frelons se logent souvent sous les toitures et dans les haies. Nous privilégions une approche prudente et sécurisée pour chaque situation.",
    nearby: ["mortain-bocage", "le-teilleul", "villedieu-les-poeles"],
  },
  {
    slug: "villedieu-les-poeles",
    name: "Villedieu-les-Poêles",
    cp: "50800",
    blurb:
      "Cité du cuivre au patrimoine bâti dense, Villedieu-les-Poêles présente de nombreux combles et cavités où s'installent guêpes et frelons. Nous intervenons avec soin sur ce type d'habitat.",
    nearby: ["avranches", "granville", "coutances"],
  },
  {
    slug: "granville",
    name: "Granville",
    cp: "50400",
    blurb:
      "Sur le littoral, Granville alterne habitat ancien de la haute-ville et quartiers résidentiels. Nous y traitons les nids de guêpes et frelons ainsi que les problématiques de rongeurs en zone urbaine.",
    nearby: ["coutances", "avranches", "villedieu-les-poeles"],
  },
  {
    slug: "coutances",
    name: "Coutances",
    cp: "50200",
    blurb:
      "Autour de Coutances, l'habitat mêle bourgs et campagne. Nous intervenons contre les frelons, les guêpes et les rongeurs, avec des conseils de prévention adaptés à chaque foyer.",
    nearby: ["granville", "saint-lo", "villedieu-les-poeles"],
  },
  {
    slug: "saint-lo",
    name: "Saint-Lô",
    cp: "50000",
    blurb:
      "Préfecture de la Manche, Saint-Lô combine tissu urbain et périphérie pavillonnaire. Nous répondons aux demandes des particuliers, professionnels et collectivités du secteur.",
    nearby: ["coutances", "cherbourg-en-cotentin", "granville"],
  },
  {
    slug: "cherbourg-en-cotentin",
    name: "Cherbourg-en-Cotentin",
    cp: "50100",
    blurb:
      "Au nord du département, Cherbourg-en-Cotentin est desservie selon disponibilité. Contactez-nous pour vérifier notre délai d'intervention dans le Cotentin.",
    nearby: ["saint-lo", "coutances"],
  },
];

export const getLocality = (slug) => LOCALITIES.find((l) => l.slug === slug);

// ---------------------------------------------------------------------------
// SERVICES
// ---------------------------------------------------------------------------
export const SERVICES = [
  {
    slug: "frelons-asiatiques",
    nav: "Frelons asiatiques",
    title: "Destruction de nids de frelons asiatiques dans la Manche",
    h1: "Destruction de nids de frelons asiatiques",
    short: "Identification, sécurisation et destruction des nids.",
    image: "/images/asian-hornet-nest.webp",
    alt: "Nid de frelons asiatiques (Vespa velutina) suspendu dans un arbre",
    metaTitle: "Destruction nid de frelon asiatique Manche | FRELONS50",
    metaDescription:
      "Destruction de nids de frelons asiatiques dans la Manche : identification, sécurisation et intervention adaptée. Contact rapide au 06 35 92 21 49.",
    intro:
      "Le frelon asiatique (Vespa velutina) construit souvent des nids volumineux en hauteur, dans les arbres, sous les toitures ou dans les dépendances. Un nid peut présenter un risque lorsqu'il est dérangé. Nous identifions la situation, sécurisons la zone et procédons à la destruction avec un équipement adapté.",
    points: [
      "Identification de l'espèce et localisation du nid",
      "Évaluation de l'accessibilité et du niveau d'urgence",
      "Sécurisation de la zone et éloignement des personnes",
      "Traitement professionnel avec équipement de protection",
      "Conseils de prévention après intervention",
    ],
    faq: [
      {
        q: "Comment reconnaître un frelon asiatique ?",
        a: "Le frelon asiatique est plus sombre que le frelon européen, avec un thorax noir, des pattes jaunes à l'extrémité et un anneau orangé sur l'abdomen. Observez à distance sans vous approcher.",
      },
      {
        q: "Le nid est très haut, pouvez-vous intervenir ?",
        a: "La faisabilité dépend de la hauteur et de l'accessibilité. Envoyez-nous une photo prise à distance : nous vous indiquons la solution la plus adaptée à la situation observée.",
      },
      {
        q: "Que faire en attendant l'intervention ?",
        a: "Ne vous approchez pas du nid, ne bouchez pas son entrée et n'essayez pas de le détruire vous-même. Éloignez les enfants et les animaux.",
      },
    ],
  },
  {
    slug: "frelons-europeens",
    nav: "Frelons européens",
    title: "Intervention contre les frelons européens dans la Manche",
    h1: "Intervention contre les frelons européens",
    short: "Évaluation de la situation et intervention adaptée.",
    image: "/images/european-hornet.webp",
    alt: "Frelon européen (Vespa crabro) posé sur du bois",
    metaTitle: "Nid de frelon européen Manche | FRELONS50",
    metaDescription:
      "Intervention contre les frelons européens dans la Manche : évaluation et traitement adapté. Contact rapide au 06 35 92 21 49.",
    intro:
      "Le frelon européen (Vespa crabro) installe fréquemment ses nids dans les cavités : troncs creux, combles, murs ou dépendances. Nous évaluons la situation puis proposons une intervention adaptée à l'emplacement et à l'accessibilité du nid.",
    points: [
      "Évaluation de l'emplacement et de l'accessibilité",
      "Identification de l'activité observée",
      "Sécurisation de la zone d'intervention",
      "Traitement adapté à la configuration du nid",
      "Recommandations de prévention",
    ],
    faq: [
      {
        q: "Le frelon européen est-il dangereux ?",
        a: "Comme tout hyménoptère, il peut piquer s'il se sent menacé. Un nid dérangé augmente le risque. Ne tentez pas de le traiter vous-même.",
      },
      {
        q: "Où se trouvent généralement les nids ?",
        a: "Souvent dans des cavités abritées : combles, troncs creux, murs, dépendances. Un professionnel évalue l'accès en toute sécurité.",
      },
    ],
  },
  {
    slug: "guepes",
    nav: "Guêpes",
    title: "Destruction de nids de guêpes dans la Manche",
    h1: "Destruction de nids de guêpes",
    short: "Traitement des nids dans les murs, toitures, sols, combles et dépendances.",
    image: "/images/wasp-nest.webp",
    alt: "Nid de guêpes sous l'avancée de toit d'une habitation",
    metaTitle: "Destruction nid de guêpes Manche | FRELONS50",
    metaDescription:
      "Destruction de nids de guêpes dans la Manche : murs, toitures, sols, combles et dépendances. Contact rapide au 06 35 92 21 49.",
    intro:
      "Les guêpes s'installent dans des endroits variés : murs, toitures, sols, combles et dépendances. Nous localisons le nid, sécurisons la zone et procédons à un traitement adapté à son emplacement.",
    points: [
      "Localisation du nid et de la zone de passage",
      "Évaluation du niveau d'urgence",
      "Sécurisation et éloignement des personnes",
      "Traitement adapté à l'emplacement",
      "Conseils de prévention",
    ],
    faq: [
      {
        q: "Le nid est dans un mur, est-ce un problème ?",
        a: "Les nids en cavité (mur, sol, toiture) nécessitent une approche spécifique. Décrivez-nous l'emplacement et joignez une photo si possible.",
      },
      {
        q: "Puis-je boucher le trou d'entrée ?",
        a: "Non. Boucher l'entrée peut rediriger les guêpes vers l'intérieur du logement et augmenter le risque. Contactez-nous d'abord.",
      },
    ],
  },
  {
    slug: "rats-et-souris",
    nav: "Rats et souris",
    title: "Dératisation : traitement des rats et souris dans la Manche",
    h1: "Dératisation : rats et souris",
    short: "Diagnostic, dératisation, pose de dispositifs et conseils de prévention.",
    image: "/images/rodents.webp",
    alt: "Rongeurs près des fondations en pierre d'une maison rurale",
    metaTitle: "Dératisation Manche — rats & souris | FRELONS50",
    metaDescription:
      "Dératisation dans la Manche : diagnostic, traitement des rats et souris, pose de dispositifs et conseils de prévention. Contact au 06 35 92 21 49.",
    intro:
      "Les rats et souris peuvent causer des dégâts et poser des questions d'hygiène. Nous réalisons un diagnostic, mettons en place des dispositifs adaptés et vous accompagnons avec des conseils de prévention durables.",
    points: [
      "Diagnostic et repérage des points de passage",
      "Mise en place de dispositifs adaptés",
      "Sécurisation vis-à-vis des enfants et animaux",
      "Suivi et recommandations",
      "Conseils de prévention (accès, stockage, étanchéité)",
    ],
    faq: [
      {
        q: "Comment savoir si j'ai des rongeurs ?",
        a: "Traces, bruits nocturnes, déjections, emballages rongés ou odeurs peuvent indiquer une présence. Un diagnostic permet de confirmer et de localiser les passages.",
      },
      {
        q: "Les dispositifs sont-ils sûrs pour mes animaux ?",
        a: "Nous adaptons les dispositifs à votre environnement et vous conseillons sur les précautions à prendre.",
      },
    ],
  },
  {
    slug: "autres-nuisibles",
    nav: "Autres nuisibles",
    title: "Autres nuisibles : décrivez votre problème",
    h1: "Autres nuisibles",
    short: "Décrivez le problème rencontré, nous vous orientons.",
    image: "/images/technician.webp",
    alt: "Technicien équipé intervenant contre les nuisibles sur une habitation rurale",
    metaTitle: "Autres nuisibles Manche | FRELONS50",
    metaDescription:
      "Un autre nuisible ? Décrivez votre situation dans la Manche et nous vous indiquons la solution la plus adaptée. Contact au 06 35 92 21 49.",
    intro:
      "Vous êtes confronté à un nuisible qui n'apparaît pas dans nos catégories ? Décrivez-nous la situation via le formulaire. Nous vous indiquons la solution la plus adaptée à ce qui est observé, ou nous vous orientons vers le bon interlocuteur.",
    points: [
      "Description libre de la situation",
      "Envoi de photos prises à distance",
      "Première évaluation à distance",
      "Orientation vers la solution adaptée",
    ],
    faq: [
      {
        q: "Intervenez-vous sur tous les nuisibles ?",
        a: "Décrivez-nous votre situation : nous vous indiquons si nous pouvons intervenir ou vous orientons vers un professionnel adapté.",
      },
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);

// ---------------------------------------------------------------------------
// CONSEILS (articles)
// ---------------------------------------------------------------------------
export const ARTICLES = [
  {
    slug: "reconnaitre-frelon-asiatique",
    title: "Comment reconnaître un frelon asiatique ?",
    excerpt:
      "Taille, couleurs, comportement : les repères simples pour distinguer le frelon asiatique du frelon européen, sans jamais vous approcher.",
    image: "/images/asian-hornet-nest.webp",
    alt: "Nid de frelons asiatiques dans un arbre",
    body: [
      "Le frelon asiatique (Vespa velutina) se distingue par un corps globalement plus sombre que celui du frelon européen. Son thorax est noir, l'extrémité de ses pattes est jaune et son abdomen présente un anneau orangé.",
      "Il vole souvent en faisant du surplace, notamment à proximité des ruches. Ses nids, volumineux et sphériques, sont fréquemment installés en hauteur dans les arbres, mais aussi sous les toitures ou dans les dépendances.",
      "Important : observez toujours à distance. Ne cherchez pas à vous approcher pour identifier précisément l'insecte ou le nid. En cas de doute, prenez une photo à distance et envoyez-la-nous : nous vous aiderons à évaluer la situation.",
    ],
  },
  {
    slug: "ou-sont-les-nids",
    title: "Où les nids sont-ils généralement installés ?",
    excerpt:
      "Toitures, gouttières, arbres, murs ou dépendances : les emplacements les plus fréquents des nids de frelons et de guêpes.",
    image: "/images/wasp-nest.webp",
    alt: "Nid installé sous l'avancée d'un toit",
    body: [
      "Les nids se trouvent souvent dans des endroits abrités : sous les avancées de toit, dans les gouttières, les combles, les troncs creux, les haies, les murs ou les dépendances.",
      "Les frelons asiatiques privilégient les emplacements en hauteur, tandis que les guêpes s'installent volontiers dans des cavités proches des habitations, y compris au niveau du sol.",
      "Si vous repérez un va-et-vient régulier d'insectes à un endroit précis, il peut s'agir d'une entrée de nid. Ne bouchez pas cette ouverture et ne tentez aucune manipulation : contactez un professionnel.",
    ],
  },
  {
    slug: "que-faire-nid",
    title: "Que faire lorsque l'on découvre un nid ?",
    excerpt:
      "Les bons réflexes de sécurité : garder ses distances, protéger enfants et animaux, et faire appel à un professionnel.",
    image: "/images/hero-rural.webp",
    alt: "Habitation rurale de la Manche",
    body: [
      "Un nid peut présenter un risque lorsqu'il est dérangé. Ne vous approchez pas, ne bouchez pas l'entrée du nid et n'essayez pas de le détruire vous-même.",
      "Éloignez les enfants et les animaux de la zone, fermez les fenêtres à proximité si nécessaire, et évitez les mouvements brusques ou les vibrations près du nid.",
      "Contactez-nous pour évaluer la situation. Lorsque cela est possible, envoyez une photo prise à distance : cela facilite la première évaluation et nous permet de vous indiquer la solution la plus adaptée.",
    ],
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);

// ---------------------------------------------------------------------------
// PROCESSUS D'INTERVENTION
// ---------------------------------------------------------------------------
export const PROCESS = [
  {
    step: "01",
    title: "Prise de contact",
    text: "Vous décrivez la situation et pouvez envoyer des photos prises à distance.",
  },
  {
    step: "02",
    title: "Première évaluation",
    text: "Identification du nuisible, de l'accessibilité et du niveau d'urgence.",
  },
  {
    step: "03",
    title: "Intervention sur place",
    text: "Sécurisation de la zone et traitement professionnel adapté.",
  },
  {
    step: "04",
    title: "Conseils et suivi",
    text: "Explications après intervention et recommandations de prévention.",
  },
];

// ---------------------------------------------------------------------------
// POURQUOI NOUS CHOISIR
// ---------------------------------------------------------------------------
export const REASONS = [
  { title: "Professionnel local", text: "Une entreprise implantée dans la Manche, proche de chez vous." },
  { title: "Intervention rapide", text: "Nous évaluons votre situation et intervenons dès que possible." },
  { title: "Explications claires", text: "Nous vous expliquons la situation et la solution la plus adaptée." },
  { title: "Traitement adapté", text: "Chaque intervention est ajustée au nuisible et à l'emplacement." },
  { title: "Contact simplifié", text: "Par téléphone ou via un formulaire simple, en quelques secondes." },
];

// ---------------------------------------------------------------------------
// INFORMATIONS LÉGALES (À COMPLÉTER en accord avec l'entreprise)
// Ne pas inventer ces informations.
// ---------------------------------------------------------------------------
export const LEGAL = {
  raisonSociale: "Ludovic Vandoolaeghe",
  formeJuridique: "Entrepreneur individuel (micro-entreprise / régime micro-social)",
  siren: "102 524 782",
  siret: "102 524 782 00012",
  adresse: "5 route de Mortain, 50640 Le Teilleul",
  ape: "8129A — Désinfection, désinsectisation et dératisation",
  activite: "Destruction nuisible frelons (activité artisanale)",
  directeurPublication: "Ludovic Vandoolaeghe",
  hebergeur: "Netlify, Inc. — 512 2nd Street, Suite 200, San Francisco, CA 94107, États-Unis — netlify.com",
  realisation: "Pierre de Vibesite",
  certibiocide: "",
  dpo: SITE.email,
  conservationDemandes: "Les demandes sont conservées 24 mois maximum, sauf obligation légale contraire.",
};

// Types de lieu pour le formulaire
export const PLACE_TYPES = [
  "Maison",
  "Appartement",
  "Commerce",
  "Exploitation",
  "Collectivité",
  "Autre",
];

// Types de problème pour le formulaire
export const PROBLEM_TYPES = [
  "Frelon asiatique",
  "Frelon européen",
  "Guêpes",
  "Rats",
  "Souris",
  "Autre nuisible",
  "Je ne sais pas",
];
